
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/overview",
      function () {
        return require("private-next-pages/components/overview.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/overview"])
      });
    }
  